export const WEB_PUSH_KEY_NAME = "custom:webPush";
export const WEB_PUSH_KEY_DEFAULT_VALUE = "N/A";

export const API_BASE_STAGE = "Dev";
export const API_BASE_URL = `https://ez9rdsmyy9.execute-api.us-east-1.amazonaws.com/${API_BASE_STAGE}`;
export const API_KEY = "MgQx7gZ3dZ1N6T5ExZqCKbuzsAB4DNp6V1Vd1jHc";
